import { render, staticRenderFns } from "./select-dropdown.vue?vue&type=template&id=3fa0620a"
import script from "./select-dropdown.vue?vue&type=script&lang=js"
export * from "./select-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports